import React, { useState, useEffect } from "react";
import styles from "./NameAndDescription.module.sass";

// Screens
import SessionFormation from "./SessionFormation";
import TeacherInformation from "./TeacherInformation";
import AddStudentToSession from "./AddStudentToSession";

// Services
import { showSuccess, showError } from "../../../services/toast.service";

const NameAndDescription = ({ session, onUpdateSession }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sessionData, setSessionData] = useState({
    title: '',
    description: '',
    start_date: '',
    end_date: '',
    teacher_id: null,
    session_id: null, // Relation vers session_groups
    status: 'Ouvert',
    session_type: 'Présentiel',
    room: '',
    room_link: ''
  });

  // Initialiser les données de session depuis les props
  useEffect(() => {
    if (session) {
      setSessionData({
        title: session.title || '',
        description: session.description || '',
        start_date: session.start_date || '',
        end_date: session.end_date || '',
        teacher_id: session.teacher_id || null,
        session_id: session.session_id || null, // Relation vers session_groups
        status: session.status || 'Ouvert',
        session_type: session.session_type || 'Présentiel',
        room: session.room || '',
        room_link: session.room_link || '',
      });
    }
  }, [session]);

  const handleInputChange = (name, value) => {
    setSessionData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSwitchChange = (name, value) => {
    setSessionData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, value) => {
    setSessionData((prev) => ({ ...prev, [name]: value }));
  };

  // Validation des champs requis
  const validateForm = () => {
    const errors = [];
    
    if (!sessionData.title?.trim()) {
      errors.push('Le titre de la session est requis');
    }
    
    if (!sessionData.start_date) {
      errors.push('La date de début est requise');
    }
    
    if (!sessionData.end_date) {
      errors.push('La date de fin est requise');
    }
        
    if (!sessionData.teacher_id) {
      errors.push('Un professeur doit être sélectionné');
    }
    
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Validation avant soumission
    const validationErrors = validateForm();
    if (validationErrors.length > 0) {
      const errorMessage = 'Veuillez corriger les erreurs suivantes:\n' + validationErrors.join('\n');
      showError(errorMessage);
      setError(errorMessage);
      setLoading(false);
      return;
    }

    try {
      console.log('Données de session à mettre à jour:', sessionData);
      await onUpdateSession(sessionData);
    } catch (err) {
      const errorMessage =
        "Impossible de mettre à jour la session formation: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // Vérifier si le formulaire est valide pour activer/désactiver le bouton
  const isFormValid = () => {
    return validateForm().length === 0;
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.formContainer}>
          {error && <div className={styles.error}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <SessionFormation
              sessionData={sessionData}
              onInputChange={handleInputChange}
              onSwitchChange={handleSwitchChange}
              onDropdownChange={handleDropdownChange}
            />
            <TeacherInformation
              sessionData={sessionData}
              onInputChange={handleInputChange}
              onSwitchChange={handleSwitchChange}
              onDropdownChange={handleDropdownChange}
            />
          </form>
          
          {/* Section pour ajouter des élèves manuellement */}
          {session && (
            <AddStudentToSession 
              session={session}
              onStudentAdded={() => {
                // Optionnel: on pourrait rafraîchir la session ici si nécessaire
              }}
              onSubmit={handleSubmit}
              loading={loading}
              isDetailMode={true}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default NameAndDescription;
